// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_OverridesListResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Staff-only listing of all per-franchise pricing overrides currently in
 * force — GET /ai/credits/pricing/overrides. Full-gated only.
 */
import type { AiCredits_OverrideRow } from './AiCredits_OverrideRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface AiCredits_OverridesListResponseDados {
rows: AiCredits_OverrideRow[]
}

export type AiCredits_OverridesListResponse = ApiResponse<AiCredits_OverridesListResponseDados>;

registerResponseContract('AiCredits_OverridesListResponse', {
  rows: {
    type: 'array',
    required: true,
    items: {
      id:                    { type: 'number',  required: true },
      franquia_id:           { type: 'number',  required: true },
      model_name:            { type: 'string',  required: true },
      cache_hit_usd_per_1m:  { type: 'string',  required: true },
      cache_miss_usd_per_1m: { type: 'string',  required: true },
      output_usd_per_1m:     { type: 'string',  required: true },
      valid_from:            { type: 'string',  required: true },
      valid_to:              { type: 'string',  required: false },
    },
  },
})
